import FormControlLabel from '@mui/material/FormControlLabel';
import RadioSelect from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from "react";
import { Paper } from '@mui/material';
import { DateSelectorState, handleRadioChange } from '../helpers';
import { useStore } from '..';
import useDebugInformation from './../../../../../../../../../hooks/useDebugInformation';

// namespace constants
const name = "DayTimeRadios";

// DayTimeRadiosProps type
type DayTimeRadiosProps = {
    parent: string
    row?: boolean
}

const changeHandler = (event: React.BaseSyntheticEvent, appointmentDate: Date | undefined, setAll: (value: DateSelectorState) => void) => {
    const { value } = event.target;
    appointmentDate = new Date(appointmentDate as Date);
    setAll({ ...handleRadioChange(value || "am", appointmentDate!) as any });
}

const DayTimeRadios: React.FC<DayTimeRadiosProps> = ({ parent, row }) => {
    const [appointmentRadios, , setAll] = useStore((store => store.appointmentRadios));
    const [appointmentTime, ,] = useStore((store => store.appointmentTime));
    const [appointmentDate, ,] = useStore((store => store.appointmentDate));

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { debugName, appointmentRadios, appointmentTime })

    return (
        <Paper elevation={2}>
            <RadioGroup name="AppointmentTime" aria-label="time-of-day"
                value={appointmentTime ? appointmentTime : "am"}
                row={row} sx={{ padding: 1, mt: 1, justifyContent: "center" }}
                onChange={(e: React.BaseSyntheticEvent) => changeHandler(e, appointmentDate, setAll)}>
                <FormControlLabel style={{ margin: 0 }}
                    disabled={!appointmentRadios.am}
                    value="am"
                    control={<RadioSelect color="primary" />}
                    label="AM"
                    labelPlacement="end"
                />
                <FormControlLabel style={{ margin: 0 }}
                    disabled={!appointmentRadios.pm}
                    value="pm"
                    control={<RadioSelect color="primary" />}
                    label="PM"
                    labelPlacement="end"
                />
                <FormControlLabel style={{ margin: 0 }}
                    value="eve"
                    control={<RadioSelect color="primary" />}
                    label="EVE"
                    labelPlacement="end"
                />
            </RadioGroup>
        </Paper >
    );
}

DayTimeRadios.displayName = name;


export default React.memo(DayTimeRadios);